export default "__VITE_ASSET__85e0f6a3__"